module.exports = __webpack_public_path__ + "img/highres.9821b0f2.svg";